import request from '@/utils/request'
import requestNoMessage from '@/utils/request-no-message'

/**
 * @description 获取订单总数
 */
function orderTotal(params) {
  return requestNoMessage({
    url: '/ajax_order_total',
    method: 'get',
    params
  })
}

/**
 * @description 提交订单--考研辅导
 */
function submitOrder(data) {
  return request({
    url: '/api/ajax_graduate_order',
    method: 'post',
    data
  })
}

/**
 * @description 获取订单列表--考研辅导
 */
function getOrderList(params) {
  return request({
    url: '/ajax_graduate_order_list',
    method: 'get',
    params
  })
}

/**
 * @description 订单确认完成--考研辅导
 */
function orderFinish(data) {
  return request({
    url: '/api/ajax_finish',
    method: 'post',
    data
  })
}

/**
 * @description 订单确认报价--考研辅导
 */
function confirmPrice(data) {
  return request({
    url: '/api/ajax_confirm_graduate_price',
    method: 'post',
    data
  })
}

/**
 * @description 上传付款凭证-考研辅导
 */
function submitPayImg(data) {
  return request({
    url: '/api/ajax_graduate_submit_pay_img',
    method: 'post',
    data
  })
}

/**
 * @description 上传押金凭证，押金前置，确认报价时候调用的接口-考研辅导
 */
function uploadPaymentVoucher(data) {
  return request({
    url: '/ajax_deposit_img',
    method: 'post',
    data
  })
}

export {
  orderTotal,
  submitOrder,
  getOrderList,
  orderFinish,
  confirmPrice,
  submitPayImg,
  uploadPaymentVoucher
}